import { useMutation } from 'react-query';

import { deleteSegment as mutationFn } from 'api/endPoints/deleteSegment';

export const useMutationDeleteSegment = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

export interface QueryParams {
    segmentId: number;
}
